import { FC } from "react";
import FormInput from "../FormInput";
import useFormsStore from "../../store/formValuesStore";
import { useTranslation } from "react-i18next";

const SecondForm: FC = () => {
  const { values, setValue } = useFormsStore();
  const handleChange = (id: number) => (value: string) => {
    setValue(id, value);
  };
  const { t } = useTranslation();

  return (
    <div className="flex gap-y-[30px] flex-col">
      <FormInput
        onChangeText={handleChange(1)}
        value={values[1].value}
        label={t("questions.2")}
      />
      <FormInput
        onChangeText={handleChange(2)}
        value={values[2].value}
        label={t("questions.3")}
      />
    </div>
  );
};

export default SecondForm;
